import type { OrgBlock } from './types';
// Danh mục cơ cấu của Mint-HR (script board: DEPT0 · TITLE0 · LEVEL0 · POSD). Dữ liệu mẫu, chỉ đọc; không lương / tiền.
// Nguồn thật về sau: TblDepartment / TblPosition qua DataSource (J-09).

/** [mã, tên VN, tên EN, thuộc, loại, ghế trưởng] */
export type DeptRow = readonly [code: string, vi: string, en: string, parent: string, type: string, head: string];
/** [mã, tên, phòng, báo cáo cho, bậc từ, bậc đến, định biên, dịch vụ, thẩm quyền] */
export type TitleRow = readonly [code: string, name: string, dept: string, rep: string, lmin: string, lmax: string, plan: number, svc: readonly string[], auth: readonly string[]];
/** [mã, tên EN, tên VN, quản lý (1 = có)] */
export type LevelRow = readonly [code: string, en: string, vi: string, mgr: number];

export const DEPTS: readonly DeptRow[] = [
  ['BOD', 'Ban Giám đốc', 'Board of Directors', '', 'Ban', 'BOD-DIR'],
  ['SALE', 'Kinh doanh', 'Sales', 'BOD', 'Phòng', 'SALE-MGR'],
  ['CSD', 'Dịch vụ khách hàng', 'Customer Service', 'BOD', 'Phòng', 'CSD-MGR'],
  ['CSD-T1', 'Tổ Dịch vụ khách hàng', 'Customer Service', 'CSD', 'Tổ', 'CSD-TL'],
  ['CSD-T2', 'Tổ Đặt chỗ', 'Operations Coordination', 'CSD', 'Tổ', ''],
  ['OPS', 'Vận hành', 'Operations', 'BOD', 'Phòng', 'OPS-MGR'],
  ['TRD', 'Vận tải', 'Transport', 'BOD', 'Phòng', 'TRD-MGR'],
  ['ACC', 'Kế toán — Tài chính', 'Accounting - Finance', 'BOD', 'Phòng', 'ACC-CA'],
  ['ACC-T1', 'Tổ Kế toán chi phí', 'Accounting - Cost', 'ACC', 'Tổ', ''],
  ['ACC-T2', 'Tổ Kế toán bán hàng — Công nợ', 'Accounting - Sales', 'ACC', 'Tổ', ''],
  ['HRD', 'Hành chính — Nhân sự — IT', 'Admin - HR - IT', 'BOD', 'Phòng', 'HRD-MGR'],
];

const PAY = ['CREDIT-OVERRIDE', 'PAYMENT-APPROVE', 'WRITE-OFF'] as const;

export const TITLES: readonly TitleRow[] = [
  ['BOD-DIR', 'Giám đốc', 'BOD', '', 'L09', 'L09', 1, [], PAY],
  ['BOD-DDIR', 'Phó Giám đốc', 'BOD', 'BOD-DIR', 'L08', 'L08', 1, [], []],
  ['SALE-MGR', 'Trưởng phòng Kinh doanh', 'SALE', 'BOD-DIR', 'L07', 'L07', 1, ['ISR', 'CCF', 'SCY', 'COO', 'FUM', 'PTF', 'TRF', 'DDL', 'FRT'], []],
  ['SALE-SE', 'Nhân viên Kinh doanh', 'SALE', 'SALE-MGR', 'L02', 'L05', 3, [], []],
  ['SALE-OVS', 'Nhân viên Oversea', 'SALE', 'SALE-MGR', 'L02', 'L05', 1, ['FRT'], []],
  ['SALE-PRC', 'Nhân viên Pricing', 'SALE', 'SALE-MGR', 'L02', 'L05', 1, ['FRT'], []],
  ['CSD-MGR', 'Trưởng phòng DVKH', 'CSD', 'BOD-DIR', 'L07', 'L07', 1, ['DDL', 'ISR'], []],
  ['CSD-TL', 'Trưởng nhóm DVKH', 'CSD-T1', 'CSD-MGR', 'L06', 'L06', 1, [], []],
  ['CSD-CSO', 'Nhân viên DVKH', 'CSD-T1', 'CSD-TL', 'L02', 'L05', 8, [], []],
  ['CSD-BKG', 'Nhân viên Đặt chỗ', 'CSD-T2', 'CSD-MGR', 'L01', 'L04', 4, ['FRT'], []],
  ['OPS-MGR', 'Trưởng phòng Vận hành', 'OPS', 'BOD-DIR', 'L07', 'L07', 1, ['CCF', 'COO', 'SCY', 'FUM', 'PTF'], []],
  ['OPS-DOC', 'Nhân viên chứng từ', 'OPS', 'OPS-MGR', 'L02', 'L04', 3, [], []],
  ['OPS-FLD', 'Nhân viên hiện trường', 'OPS', 'OPS-MGR', 'L02', 'L04', 3, [], []],
  ['TRD-MGR', 'Trưởng phòng Vận tải', 'TRD', 'BOD-DIR', 'L07', 'L07', 1, ['TRF'], []],
  ['TRD-DSP', 'Nhân viên Điều độ', 'TRD', 'TRD-MGR', 'L02', 'L04', 1, [], []],
  ['TRD-DRV', 'Tài xế', 'TRD', 'TRD-DSP', 'L01', 'L03', 10, [], []],
  ['TRD-TEC', 'Cố vấn kỹ thuật', 'TRD', 'TRD-MGR', 'L03', 'L05', 1, [], []],
  ['ACC-CA', 'Kế toán trưởng', 'ACC', 'BOD-DIR', 'L07', 'L07', 1, [], PAY],
  ['ACC-CP', 'Kế toán chi phí', 'ACC-T1', 'ACC-CA', 'L02', 'L05', 1, [], ['INVOICE-IN-POST', 'ADVANCE-SETTLE']],
  ['ACC-AR', 'Kế toán bán hàng — công nợ', 'ACC-T2', 'ACC-CA', 'L02', 'L05', 1, [], ['INVOICE-ISSUE', 'CREDIT-ALERT']],
  ['ACC-TAX', 'Kế toán thuế', 'ACC', 'ACC-CA', 'L02', 'L05', 1, [], []],
  ['HRD-MGR', 'Trưởng phòng HC-NS', 'HRD', 'BOD-DIR', 'L07', 'L07', 1, [], []],
  ['HRD-IT', 'Nhân viên CNTT', 'HRD', 'HRD-MGR', 'L02', 'L04', 1, [], []],
];

export const LEVELS: readonly LevelRow[] = [
  ['L01', 'Fresher', 'Thực tập — Tập sự', 0],
  ['L02', 'Fresher', 'Nhân viên mới', 0],
  ['L03', 'Executive', 'Nhân viên', 0],
  ['L04', 'Junior', 'Nhân viên chính', 0],
  ['L05', 'Senior', 'Chuyên viên', 0],
  ['L06', 'Team Leader', 'Trưởng nhóm', 1],
  ['L07', 'Manager', 'Trưởng phòng', 1],
  ['L08', 'Deputy Director', 'Phó Giám đốc', 1],
  ['L09', 'Director', 'Giám đốc', 1],
];

export interface JdText { a: string; b: string; c: string }
/** JD gốc theo chức danh (POSD): mục đích · nhiệm vụ · yêu cầu. */
export const JD_BASE: Readonly<Record<string, JdText>> = {
  'OPS-DOC': {
    a: 'Lập và kiểm chứng từ xuất khẩu cho lô FCL / LCL đúng cut-off của hãng tàu.',
    b: ['Soạn SI, kiểm Draft B/L với hãng tàu', 'Theo dõi VGM, C/O, chứng từ gốc', 'Cập nhật trạng thái chứng từ trên HANA Ezy'].join('\n'),
    c: ['Tốt nghiệp cao đẳng trở lên', 'Tiếng Anh đọc hiểu chứng từ', 'Cẩn thận, chịu được áp lực cut-off'].join('\n'),
  },
  'TRD-DSP': {
    a: 'Điều xe container cho chuyến cảng – kho, theo dõi GPS và xử lý sự cố trên đường.',
    b: ['Gán xe, gán mooc trước 16:00', 'Theo dõi chuyến, nhận sự cố trong 15 phút', 'Đối chiếu phí cầu đường, bốc xếp'].join('\n'),
    c: ['Có kinh nghiệm điều độ vận tải là lợi thế', 'Thuộc tuyến cảng Cát Lái, Cái Mép', 'Giao tiếp tốt với tài xế'].join('\n'),
  },
  'CSD-CSO': {
    a: 'Chăm sóc lô hàng của khách từ booking đến khi phát hành B/L.',
    b: ['Nhận yêu cầu, báo trạng thái lô cho khách', 'Phối hợp Booking, Chứng từ, Vận tải', 'Xử lý mail khách trong 5 phút giờ làm việc'].join('\n'),
    c: ['Tốt nghiệp cao đẳng trở lên', 'Tiếng Anh giao tiếp qua mail', 'Chủ động, cẩn thận'].join('\n'),
  },
  'SALE-SE': {
    a: 'Tìm và giữ khách xuất khẩu tuyến Mỹ, châu Âu, nội Á.',
    b: ['Báo giá cước biển, air, trucking', 'Chăm sóc khách hiện có, mở khách mới', 'Theo dõi lô hàng cùng CS'].join('\n'),
    c: ['Có kinh nghiệm forwarder là lợi thế', 'Tiếng Anh giao tiếp', 'Chịu đi gặp khách'].join('\n'),
  },
};

export type OrgListKey = 'dept' | 'title' | 'level';
export interface OrgCell { v: string; strong?: boolean; tone?: 'link' | 'warn' | 'mute' }
export interface OrgListRow { key: string; cells: OrgCell[]; delTone: 'err' | 'mute'; delTip: string }
export interface OrgList { cols: ReadonlyArray<readonly [string, string]>; rows: OrgListRow[]; note: string }

const holdOf = (blocks: readonly OrgBlock[]) => {
  const m: Record<string, number> = {};
  for (const b of blocks) for (const d of b.depts) for (const s of d.seats) m[s.code] = s.holders.length;
  return m;
};

/** Bảng Phòng ban / Chức danh / Bậc (khối `orgList` của board). `blocks` = ghế hiện có để tính định biên. */
export function buildOrgList(key: OrgListKey, blocks: readonly OrgBlock[]): OrgList {
  if (key === 'dept') {
    return {
      cols: [['Mã', '10%'], ['Tên VN · EN', '30%'], ['Thuộc', '10%'], ['Loại', '9%'], ['Ghế trưởng', '13%'], ['Chức danh', '10%']],
      note: 'Đổi cây có hiệu lực từ ngày BOD duyệt.',
      rows: DEPTS.map((d) => {
        const kids = TITLES.filter((x) => x[2] === d[0]).length + DEPTS.filter((x) => x[3] === d[0]).length;
        return {
          key: d[0],
          cells: [{ v: d[0], strong: true, tone: 'link' }, { v: `${d[1]} · ${d[2]}` }, { v: d[3] || '—' }, { v: d[4] }, { v: d[5] || '—' }, { v: String(kids) }],
          delTone: kids ? 'mute' : 'err',
          delTip: kids ? `Còn ${kids} chức danh / tổ trực thuộc` : 'Xoá phòng',
        };
      }),
    };
  }
  if (key === 'title') {
    const hold = holdOf(blocks);
    return {
      cols: [['Mã', '11%'], ['Tên chức danh', '20%'], ['Phòng', '8%'], ['Báo cáo cho', '11%'], ['Bậc', '9%'], ['Định biên', '9%'], ['Dịch vụ · thẩm quyền', '18%']],
      note: 'Dịch vụ phụ trách và thẩm quyền đi theo ghế.',
      rows: TITLES.map((x) => {
        const h = hold[x[0]] ?? 0;
        return {
          key: x[0],
          cells: [
            { v: x[0], strong: true, tone: 'link' }, { v: x[1] }, { v: x[2] }, { v: x[3] || '—' },
            { v: x[4] === x[5] ? x[4] : `${x[4]}–${x[5]}` },
            { v: `${h}/${x[6]}`, tone: h < x[6] ? 'warn' : undefined },
            { v: [...x[7], ...x[8]].join(', ') || '—', tone: 'mute' },
          ],
          delTone: h ? 'mute' : 'err',
          delTip: h ? `${h} người đang giữ ghế` : 'Xoá chức danh',
        };
      }),
    };
  }
  return {
    cols: [['Mã', '10%'], ['Tên EN', '18%'], ['Tên VN', '22%'], ['Quản lý', '10%'], ['Chức danh dùng', '12%'], ['Khung lương · hạn mức duyệt', '18%']],
    note: '9 bậc cố định.',
    rows: LEVELS.map((l) => ({
      key: l[0],
      cells: [
        { v: l[0], strong: true, tone: 'link' }, { v: l[1] }, { v: l[2] }, { v: l[3] ? 'Có' : 'Không' },
        { v: String(TITLES.filter((x) => x[4] <= l[0] && x[5] >= l[0]).length) },
        { v: 'Ở Bảng lương · chờ anh chốt', tone: 'mute' },
      ],
      delTone: 'mute',
      delTip: '',
    })),
  };
}

/** Bậc hợp lệ của một chức danh (trong khung bậc của chức danh). */
export const levelsOf = (t: TitleRow): string[] => LEVELS.map((l) => l[0]).filter((c) => c >= t[4] && c <= t[5]);

export function jdFor(t: TitleRow, lv: string): JdText {
  return JD_BASE[t[0]] ?? { a: `Mục đích công việc của ${t[1]}.`, b: 'Nhiệm vụ chính theo chức danh', c: `Yêu cầu theo bậc ${lv}` };
}
